module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-1054-retro.4ed39649.jpg";